var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30L27.5 35L37.5 25",
    stroke: "#1DB954",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 7.5C35.8397 12.6664 43.4613 15.3564 51.2501 15C52.3841 18.8575 52.731 22.9037 52.2704 26.898C51.8097 30.8922 50.5509 34.7532 48.5686 38.2513C46.5863 41.7495 43.921 44.8135 40.7312 47.2612C37.5414 49.7089 33.892 51.4905 30.0001 52.5C26.1081 51.4905 22.4588 49.7089 19.2689 47.2612C16.0791 44.8135 13.4138 41.7495 11.4316 38.2513C9.44928 34.7532 8.19041 30.8922 7.72976 26.898C7.26912 22.9037 7.61609 18.8575 8.75007 15C16.5389 15.3564 24.1605 12.6664 30.0001 7.5",
    stroke: "#1DB954",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.7d58c199cc65476107324bf213633ac1.svg";
export { ForwardRef as ReactComponent };